export default "__VITE_ASSET__Bve9$226__"